module.exports = __webpack_public_path__ + "static/media/mundin-tele.c959f9f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/logo/mundin-tele.png
// module id = 223
// module chunks = 0